import {useChatState} from '@github-ui/copilot-chat-contexts/ChatStateContext'
import {copilotLocalStorage} from '@github-ui/copilot-chat-helpers/copilot-local-storage'
import {getSelectedThread} from '@github-ui/copilot-chat-state/get-selected-thread'
import {useEffect, useRef} from 'react'

import {useChatManager} from '../utils/CopilotChatManagerContext'

export function useChat(inputRef?: React.RefObject<HTMLTextAreaElement | null>) {
  const state = useChatState()
  const manager = useChatManager()
  const {currentTopic, messages, selectedThreadID} = state
  const thread = getSelectedThread(state)
  const chatTextAreaRef = useRef<HTMLTextAreaElement>(null)
  const textAreaRef = inputRef || chatTextAreaRef

  useEffect(() => {
    if (thread && messages.length > 0) {
      manager.showTopicPicker(false)
    }
  }, [thread, messages.length, manager])

  useEffect(() => {
    const topicID = currentTopic ? String(currentTopic.id) : null
    if (selectedThreadID && topicID) {
      copilotLocalStorage.setSelectedTopic(selectedThreadID, topicID)
    }
  }, [selectedThreadID, currentTopic])

  useEffect(() => {
    const timeout = window.setTimeout(() => {
      textAreaRef.current?.focus()
    }, 1)
    return () => {
      window.clearTimeout(timeout)
    }
  }, [textAreaRef])

  return {textAreaRef}
}
